import { render, staticRenderFns } from "./CreerAttestation.vue?vue&type=template&id=0fafd976"
import script from "./CreerAttestation.vue?vue&type=script&lang=js"
export * from "./CreerAttestation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports